import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell
} from "@material-ui/core";
import AcademicYearService from "./Locality/Service/academicYearService";
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#1a1a1aad",
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function AcademicYear() {
    const tableHeaders = [ 'Acadamic Year', 'Status',  'edit', 'delete'];
    const classes = useStyles();
    const [academicYearList, setAcademicYearList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [academicYear, setAcademicYear] = useState({
        acadamicYear: '',
        status: 'Active',
    });
    useEffect(() => {
        getAcademicYearList();
        return () => {
            setAcademicYearList([])
        }
    }, []);
    const handleOpen = (status) => {
      if(status){
        setAcademicYear({
          acadamicYear: '',
          status: 'Active',
        })
      }
   
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const getAcademicYearList = () => {
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      
        AcademicYearService.getAllAcademicYear(userDetails.schooleId).then((res) => {
            setAcademicYearList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const validationSchema = Yup.object().shape({
        acadamicYear: Yup.string().required(' required'),
    });
   
    const editAcademicYear = (row ) => {
        setAcademicYear(row)
        handleOpen(false);
     
      }
      const deleteAcademicYear = (row) => {
        if (row) {
          AcademicYearService.deleteAcademicYear(row).then((res) => {
            getAcademicYearList();
          }).catch((err) => {
          });
        }
      };
    const formik = useFormik({
        initialValues: academicYear,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if(academicYear._id){
                AcademicYearService.updateAcademicYear(values).then((res) => {
                    handleClose();
                    getAcademicYearList();
                    resetForm()
                    alert(" Updated Successfully.");
                    
                  }).catch((err) => {
                   
                  });
            }
            else {
                    AcademicYearService.createAcademicYear(values).then((res) => {
                        getAcademicYearList();
                        handleClose();
                        resetForm();
                        alert("  Added Successfully.");
                    })
                
                .catch((err) => {
                    
                    alert(err.response.data.message)
                })
        }
    },
    });
    return (
        <>
            <PageTitle title="Academic Master" button={<Button

                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{backgroundColor:'rgb(15 59 98)'}}> Add Acadamic Master
            </Button>} />
            <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table className="mb-0">
              <TableHead >
                <TableRow>
                  {tableHeaders.map(key => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>

              </TableHead>
              <TableBody>
                {academicYearList.map((row) => (
                  <TableRow key={row._id}>
        
                    <TableCell className="pl-3 fw-normal" >{row.acadamicYear}</TableCell>
                    <TableCell className="pl-3 fw-normal" >{row.status || 'Active'}</TableCell>

                    <TableCell>
                      <EditIcon style={{ cursor: 'pointer' }} onClick={() => editAcademicYear(row)} >
                      </EditIcon >
                    </TableCell>
                    <TableCell>
                      <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteAcademicYear(row)} />
                    </TableCell>
               
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Widget>
        </Grid>
      </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{academicYear._id ? "Edit Acadamic Master" : "Add Acadamic Master"}</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style= {{ width: 308 }}>
                        
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="acadamicYear"
                            name="acadamicYear"
                            label="Acadamic Year"
                            type="text"
                            variant="standard"
                            value={formik.values.acadamicYear}
                            onChange={formik.handleChange}
                            error={formik.touched.acadamicYear && Boolean(formik.errors.acadamicYear)}
                            helperText={formik.touched.acadamicYear && formik.errors.acadamicYear}
                        />
                        <FormControl variant="standard" fullWidth style={{ marginTop: 12 }}>
                          <InputLabel id="academic-year-status-label">Status</InputLabel>
                          <Select
                            labelId="academic-year-status-label"
                            id="status"
                            name="status"
                            value={formik.values.status || "Active"}
                            onChange={formik.handleChange}
                          >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                       
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" >{academicYear._id ? "Update" : "Add"}</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
